module.exports = __webpack_public_path__ + "img/18.208bc744.jpg";